import { Link, useParams } from "react-router-dom";

import CreateEditProduct from "@/app/shared/ecommerce/product/create-edit";
import { productData } from "@/app/shared/ecommerce/product/create-edit/form-utils";
import PageHeader from "@/app/shared/page-header";
import routes from "@/routers/routes";
import { PiPlusBold } from "react-icons/pi";
import { Button } from "rizzui";

type Props = {
    params: { slug: string };
};

const pageHeader = {
    title: "Edit Product",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "E-Commerce",
        },
        {
            href: routes.eCommerce.products,
            name: "Products",
        },
        {
            name: "Edit",
        },
    ],
};

export default function EditProductPage() {
    const { id } = useParams();

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <Link
                    to={routes.eCommerce.createProduct}
                    className="mt-4 w-full @lg:mt-0 @lg:w-auto"
                >
                    <Button as="span" className="w-full @lg:w-auto">
                        <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
                        Add Product
                    </Button>
                </Link>
            </PageHeader>

            <CreateEditProduct slug={id} product={productData} />
        </>
    );
}
